module.exports = __webpack_public_path__ + "static/media/three-bunnies-803051-unsplash@3x.08d2cfa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/three-bunnies-803051-unsplash@3x.png
// module id = 679
// module chunks = 1